import { useState } from 'react';
import { fmt } from '../constants';
import { AdSlot, Breadcrumb, InsightBox, AffiliateCard, FaqItem, InputSlider, ToggleGroup, ResultItem, PageFooter } from '../components/UI';

function ShareModal({ onClose, imageDataUrl, text, url }) {
  const [copied, setCopied] = useState(false);
  const shareFacebook = () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`, '_blank', 'width=600,height=400');
  const shareTwitter = () => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank', 'width=600,height=400');
  const shareWhatsApp = () => window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
  const shareCopy = () => navigator.clipboard?.writeText(text + ' ' + url).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div className="share-modal" onClick={e => e.stopPropagation()}>
        <button className="share-modal-close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <div className="share-modal-title">Share Your Result</div>
        <div className="share-modal-subtitle">Your result is ready to share</div>
        {imageDataUrl && <img className="share-modal-preview" src={imageDataUrl} alt="Your result" />}
        <div className="share-modal-buttons">
          <button className="share-btn-fb" onClick={shareFacebook}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            Facebook
          </button>
          <button className="share-btn-tw" onClick={shareTwitter}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            Twitter
          </button>
          <button className="share-btn-wa" onClick={shareWhatsApp}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.117 1.535 5.845L.057 23.571l5.902-1.548A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 0 1-5.006-1.37l-.359-.213-3.502.919.934-3.41-.234-.371A9.817 9.817 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182c5.43 0 9.818 4.388 9.818 9.818 0 5.43-4.388 9.818-9.818 9.818z"/></svg>
            WhatsApp
          </button>
          <button className="share-btn-copy" onClick={shareCopy}>
            {copied
              ? <><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Copied!</>
              : <><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copy Link</>
            }
          </button>
        </div>
      </div>
    </div>
  );
}

function buildShareImage(lines) {
  const canvas = document.createElement('canvas');
  canvas.width = 1080; canvas.height = 1080;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#1B4332'; ctx.fillRect(0, 0, 1080, 1080);
  ctx.strokeStyle = 'rgba(255,255,255,0.04)'; ctx.lineWidth = 1;
  for (let i = 0; i < 1080; i += 60) {
    ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i, 1080); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0, i); ctx.lineTo(1080, i); ctx.stroke();
  }
  ctx.fillStyle = '#D4A017'; ctx.fillRect(80, 100, 920, 6);
  let y = 200;
  lines.forEach(({ text, style, size, color }) => {
    ctx.font = `${style || 'normal'} ${size || 48}px ${style === 'bold' ? 'Georgia, serif' : 'Manrope, sans-serif'}`;
    ctx.fillStyle = color || 'white';
    ctx.fillText(text, 80, y);
    y += (size || 48) + 36;
  });
  ctx.fillStyle = 'rgba(212,160,23,0.4)'; ctx.fillRect(80, 940, 920, 2);
  ctx.font = 'bold 30px Georgia, serif'; ctx.fillStyle = '#D4A017';
  ctx.fillText('financecalculator.cc', 80, 990);
  return canvas.toDataURL('image/png');
}

function ShareSection({ lines, text, url, title, subtitle }) {
  const [open, setOpen] = useState(false);
  const [imgData, setImgData] = useState(null);
  const handleOpen = () => { setImgData(buildShareImage(lines)); setOpen(true); };
  return (
    <>
      {open && <ShareModal onClose={() => setOpen(false)} imageDataUrl={imgData} text={text} url={url} />}
      <div className="share-section">
        <div className="share-title">{title || 'Share Your Result'}</div>
        <div className="share-subtitle">{subtitle || 'Challenge your friends to beat your number!'}</div>
        <button className="share-trigger-btn" onClick={handleOpen}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
          Share Your Result
        </button>
      </div>
    </>
  );
}

// ─── RENT ───────────────────────────────────────────────────────────────────
export function RentCalc({ currency }) {
  const [income, setIncome] = useState(5000);
  const [rent, setRent] = useState(1500);
  const [debt, setDebt] = useState(0);

  const ratio = (rent / income) * 100;
  const dti = ((rent + debt) / income) * 100;
  const maxRent = income * 0.3;
  const left = income - rent - debt;
  const status = ratio <= 30 ? 'good' : ratio <= 40 ? 'warn' : 'bad';
  const statusLabel = ratio <= 30 ? '✓ Comfortable' : ratio <= 40 ? '⚠ Stretching It' : '✗ Too Tight';
  const statusClass = ratio <= 30 ? 'status-good' : ratio <= 40 ? 'status-warn' : 'status-bad';

  const insight = ratio <= 30
    ? `You're in great shape. At ${ratio.toFixed(1)}% of your income, this apartment leaves plenty of room for savings, emergencies, and actually enjoying your life. Your estimated ${fmt(left, currency)}/month after rent and debt gives you real breathing room.`
    : ratio <= 40
    ? `This is manageable but tight. At ${ratio.toFixed(1)}% of your income, you'll need to be disciplined. Make sure you have at least 3 months of expenses (${fmt(rent * 3, currency)}) saved as a cushion before signing. Your recommended max rent would be ${fmt(maxRent, currency)}/month.`
    : `This apartment would put real financial pressure on you. At ${ratio.toFixed(1)}% of your income, unexpected expenses can quickly become a crisis. A safer option would be around ${fmt(maxRent, currency)}/month.`;

  return (
    <div>
      <div className="calc-page">
        <Breadcrumb label="Rent Affordability Calculator" />
        <h1 className="calc-page-title">Can I Afford This Apartment?</h1>
        <p className="calc-page-desc">The 30% rule is the most trusted guideline in personal finance. Enter your numbers and find out if that apartment is a smart move — or a financial trap.</p>
        <AdSlot />
        <div className="calculator-box">
          <div className="calc-inputs">
            <InputSlider label="Monthly Gross Income" value={income} min={1000} max={20000} step={100} onChange={setIncome} display={fmt(income, currency)} />
            <InputSlider label="Monthly Rent" value={rent} min={300} max={8000} step={50} onChange={setRent} display={fmt(rent, currency)} />
            <InputSlider label="Other Monthly Debt Payments" value={debt} min={0} max={3000} step={50} onChange={setDebt} display={fmt(debt, currency)} />
          </div>
          <div className="calc-results">
            <div className="result-headline">Rent-to-Income Ratio</div>
            <div className="result-big">{ratio.toFixed(1)}%</div>
            <span className={`status-badge ${statusClass}`}>{statusLabel}</span>
            <div className="result-grid">
              <ResultItem label="Recommended Max Rent" value={fmt(maxRent, currency)} variant={status} />
              <ResultItem label="Left After Rent & Debt" value={fmt(left, currency)} variant={status} />
              <ResultItem label="Debt-to-Income Ratio" value={dti.toFixed(1) + '%'} />
              <ResultItem label="Annual Rent Cost" value={fmt(rent * 12, currency)} />
            </div>
          </div>
        </div>
        <InsightBox text={insight} />
        <ShareSection
          lines={[
            { text: 'Rent Affordability', style: 'bold', size: 52, color: '#D4A017' },
            { text: `My rent is ${ratio.toFixed(1)}% of my income`, size: 44, color: 'white' },
            { text: ratio <= 30 ? 'I am in the safe zone.' : ratio <= 40 ? 'I am stretching it.' : 'It is too tight.', style: 'bold', size: 56, color: ratio <= 30 ? '#52b788' : ratio <= 40 ? '#f4a261' : '#e63946' },
            { text: 'What is your ratio?', size: 36, color: 'rgba(255,255,255,0.55)' },
          ]}
          text={`My rent is ${ratio.toFixed(1)}% of my income — ${ratio <= 30 ? "I'm in the safe zone!" : ratio <= 40 ? "I'm stretching it." : "it's too tight."} Are you paying too much?`}
          url="https://financecalculator.cc/rent"
          title="Share Your Result"
          subtitle="Are your friends overpaying for rent?"
        />
        <AdSlot />
        <div className="affiliate-section">
          <div className="affiliate-title">Recommended Next Steps</div>
          <div className="affiliate-cards">
            <AffiliateCard name="SmartCredit — Credit Score Boost" desc="Landlords check your credit before approving you. Know your score and boost it fast." cta="Check My Score" href="https://www.tkqlhce.com/click-101704075-16982685" />
            <AffiliateCard name="Northwestern Mutual" desc="Build your 3-month emergency fund and start investing automatically" cta="Get Started" href="https://www.northwesternmutual.com/get-started/investments" />
          </div>
        </div>
        <div className="faq-section">
          <div className="faq-title">Common Questions</div>
          <FaqItem q="What is the 30% rule?" a={"The 30% rule says you should spend no more than 30% of your gross monthly income on rent. It's a widely used guideline, though some financial experts now suggest 25% for more breathing room."} />
          <FaqItem q={"What's included in \"debt payments\"?"} a={"Include any recurring debt obligations: car payments, student loan minimums, credit card minimums, personal loans. Don't include subscriptions, utilities, or groceries."} />
          <FaqItem q="Should I use gross or net income?" a={"This calculator uses gross (before-tax) income, which is the standard used by landlords and lenders. If you're in a high tax bracket, be more conservative."} />
          <FaqItem q={"What if I'm over 30%?"} a="Not necessarily a dealbreaker. In high cost-of-living cities, 35-40% is common. The key is your total debt-to-income ratio stays under 43%." />
        </div>
      </div>
      <PageFooter />
    </div>
  );
}

// ─── CREDIT CARD ─────────────────────────────────────────────────────────────
export function CreditCardCalc({ currency }) {
  const [bal, setBal] = useState(5000);
  const [apr, setApr] = useState(22);
  const [pay, setPay] = useState(200);

  const monthly = apr / 100 / 12;
  const minPay = bal * monthly;
  const canPay = pay > minPay;
  const months = canPay ? Math.ceil(-Math.log(1 - (bal * monthly) / pay) / Math.log(1 + monthly)) : Infinity;
  const total = canPay ? pay * months : Infinity;
  const interest = canPay ? total - bal : Infinity;
  const yrs = Math.floor(months / 12);
  const mo = months % 12;
  const intPct = canPay ? Math.round((interest / total) * 100) : 0;
  const prinPct = 100 - intPct;
  const extra50months = canPay ? Math.ceil(-Math.log(1 - (bal * monthly) / (pay + 50)) / Math.log(1 + monthly)) : 0;
  const saved = canPay ? interest - (((pay + 50) * extra50months) - bal) : 0;

  const timeStr = !canPay ? 'Never (increase payment)' : (yrs > 0 ? `${yrs} yr${yrs > 1 ? 's' : ''} ` : '') + (mo > 0 ? `${mo} mo` : '');

  const insight = !canPay
    ? `Your current payment only covers the interest — you're not reducing the principal at all. Increase your payment above ${fmt(minPay + 1, currency)}/month to start making progress.`
    : `Of everything you pay, ${intPct}% goes straight to the bank — not your actual debt. That's ${fmt(interest, currency)} in interest on a ${fmt(bal, currency)} balance. Even adding just ${fmt(50, currency)}/month would save you approximately ${fmt(Math.max(0, saved), currency)} in interest and cut roughly ${months - extra50months} months off your payoff time.`;

  return (
    <div>
      <div className="calc-page">
        <Breadcrumb label="Credit Card Payoff Calculator" />
        <h1 className="calc-page-title">Credit Card Payoff Calculator</h1>
        <p className="calc-page-desc">See exactly how long — and how much — that balance will actually cost you. The numbers might surprise you.</p>
        <AdSlot />
        <div className="calculator-box">
          <div className="calc-inputs">
            <InputSlider label="Current Balance" value={bal} min={100} max={50000} step={100} onChange={setBal} display={fmt(bal, currency)} />
            <InputSlider label="Annual Interest Rate (APR)" value={apr} min={1} max={35} step={0.5} onChange={setApr} display={apr + '%'} />
            <InputSlider label="Monthly Payment" value={pay} min={25} max={5000} step={25} onChange={setPay} display={fmt(pay, currency)} />
          </div>
          <div className="calc-results">
            <div className="result-headline">Debt-Free In</div>
            <div className="result-big">{timeStr}</div>
            <div className="result-sub">at your current payment rate</div>
            <div className="result-grid">
              <ResultItem label="Total Interest Paid" value={canPay ? fmt(interest, currency) : '∞'} variant="bad" />
              <ResultItem label="Total Amount Paid" value={canPay ? fmt(total, currency) : '∞'} />
            </div>
            {canPay && (
              <div style={{ marginTop: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', marginBottom: 6 }}>
                  <span style={{ color: 'var(--emerald)', fontWeight: 600 }}>Principal {prinPct}%</span>
                  <span style={{ color: 'var(--red)', fontWeight: 600 }}>Interest {intPct}%</span>
                </div>
                <div className="progress-bar-wrap">
                  <div className="progress-bar-fill" style={{ background: `linear-gradient(90deg, var(--emerald) ${prinPct}%, var(--red) ${prinPct}%)`, width: '100%' }} />
                </div>
              </div>
            )}
          </div>
        </div>
        <InsightBox text={insight} />
        <ShareSection
          lines={[
            { text: 'Credit Card Payoff', style: 'bold', size: 52, color: '#D4A017' },
            { text: canPay ? `Debt-free in ${timeStr}` : 'Payment too low', style: 'bold', size: 62, color: 'white' },
            { text: canPay ? `Total interest paid: ${fmt(interest, currency)}` : 'Increase your payment', size: 40, color: 'rgba(255,255,255,0.7)' },
            { text: 'How long will yours take?', size: 36, color: 'rgba(255,255,255,0.5)' },
          ]}
          text={canPay ? `I'll be credit card debt-free in ${timeStr}. Paying ${fmt(interest, currency)} in interest. The math is eye-opening.` : `I just calculated my credit card payoff timeline. The interest number is shocking.`}
          url="https://financecalculator.cc/credit-card"
          title="Share Your Result"
          subtitle="Show your friends how much interest they're really paying"
        />
        <AdSlot />
        <div className="affiliate-section">
          <div className="affiliate-title">Ways to Pay It Off Faster</div>
          <div className="affiliate-cards">
            <AffiliateCard name="SmartCredit — Credit Monitoring" desc="Get alerted the moment your credit score changes — catch problems before they cost you." cta="Monitor My Credit" href="https://www.tkqlhce.com/click-101704075-16982682" />
            <AffiliateCard name="Northwestern Mutual" desc="Get a personalized plan to pay off debt and start building wealth" cta="Get Started" href="https://www.northwesternmutual.com/get-started/financial-advisor" />
          </div>
        </div>
        <div className="faq-section">
          <div className="faq-title">Common Questions</div>
          <FaqItem q="What's the minimum payment trap?" a="Credit card minimum payments are typically 1–3% of your balance. On a $5,000 balance at 22% APR, paying just minimums can take 15+ years and cost over $6,000 in interest alone." />
          <FaqItem q="What is a balance transfer and is it worth it?" a={"A balance transfer moves your existing card debt to a new card with a lower (often 0%) intro APR. There's typically a 3-5% transfer fee. It's worth it if you can pay off the balance before the intro period ends."} />
          <FaqItem q="Avalanche vs. Snowball — which is better?" a={"The avalanche method pays highest-interest debt first (saves the most money). The snowball method pays smallest balance first (psychological wins). The best method is the one you'll actually stick to."} />
        </div>
      </div>
      <PageFooter />
    </div>
  );
}

// ─── MORTGAGE ────────────────────────────────────────────────────────────────
export function MortgageCalc({ currency }) {
  const [inc, setInc] = useState(80000);
  const [debt, setDebt] = useState(300);
  const [dp, setDp] = useState(40000);
  const [rate, setRate] = useState(7);
  const [term, setTerm] = useState(30);

  const monthlyInc = inc / 12;
  const maxPI = monthlyInc * 0.28;
  const r = rate / 100 / 12;
  const n = term * 12;
  const loanAmt = maxPI / (r * Math.pow(1 + r, n) / (Math.pow(1 + r, n) - 1));
  const maxPrice = loanAmt + dp;
  const taxIns = Math.round(maxPrice * 0.012 / 12) + 150;
  const totalMonthly = Math.round(maxPI) + taxIns;
  const dpPct = ((dp / maxPrice) * 100).toFixed(0);

  const insight = `On a ${fmt(inc, currency)}/year income, a bank might approve you for considerably more — but the 28% rule keeps housing costs manageable. Your comfortable price is ${fmt(maxPrice, currency)}, with a monthly payment of about ${fmt(totalMonthly, currency)} all-in. ${+dpPct < 20 ? `At ${dpPct}% down, you'll likely owe Private Mortgage Insurance (PMI) until you reach 20% equity.` : `At ${dpPct}% down, you avoid Private Mortgage Insurance entirely.`}`;

  return (
    <div>
      <div className="calc-page">
        <Breadcrumb label="Home Affordability Calculator" />
        <h1 className="calc-page-title">How Much House Can I Afford?</h1>
        <p className="calc-page-desc">Get a realistic number — not a bank's optimistic pre-approval. Based on the trusted 28/36 rule.</p>
        <AdSlot />
        <div className="calculator-box">
          <div className="calc-inputs">
            <InputSlider label="Annual Gross Income" value={inc} min={30000} max={500000} step={5000} onChange={setInc} display={fmt(inc, currency)} />
            <InputSlider label="Monthly Debt Payments" value={debt} min={0} max={5000} step={50} onChange={setDebt} display={fmt(debt, currency)} />
            <InputSlider label="Down Payment Saved" value={dp} min={0} max={300000} step={5000} onChange={setDp} display={fmt(dp, currency)} />
            <InputSlider label="Interest Rate" value={rate} min={3} max={12} step={0.25} onChange={setRate} display={rate + '%'} />
            <div className="input-group">
              <div className="input-label"><span>Loan Term</span></div>
              <ToggleGroup options={[{ value: 30, label: '30 Years' }, { value: 15, label: '15 Years' }]} value={term} onChange={setTerm} />
            </div>
          </div>
          <div className="calc-results">
            <div className="result-headline">You can comfortably afford up to</div>
            <div className="result-big">{fmt(maxPrice, currency)}</div>
            <div className="result-sub">based on the 28% income rule — {term}-year loan</div>
            <div className="result-grid">
              <ResultItem label="Monthly Mortgage (P&I)" value={fmt(maxPI, currency)} variant="good" />
              <ResultItem label="Est. Tax + Insurance" value={fmt(taxIns, currency)} />
              <ResultItem label="Total Monthly Cost" value={fmt(totalMonthly, currency)} variant="warn" />
              <ResultItem label="Down Payment %" value={dpPct + '%'} />
            </div>
          </div>
        </div>
        <InsightBox text={insight} />
        <ShareSection
          lines={[
            { text: 'Home Affordability', style: 'bold', size: 52, color: '#D4A017' },
            { text: 'I can comfortably afford', size: 36, color: 'rgba(255,255,255,0.6)' },
            { text: fmt(maxPrice, currency), style: 'bold', size: 80, color: 'white' },
            { text: `Monthly payment: ${fmt(totalMonthly, currency)}/mo all-in`, size: 36, color: 'rgba(255,255,255,0.6)' },
            { text: 'Know your real number.', size: 34, color: 'rgba(255,255,255,0.45)' },
          ]}
          text={`Based on my income, I can comfortably afford a ${fmt(maxPrice, currency)} home — not what the bank says. Know your real number.`}
          url="https://financecalculator.cc/mortgage"
          title="Share Your Result"
          subtitle="Help your friends know what they can really afford"
        />
        <AdSlot />
        <div className="affiliate-section">
          <div className="affiliate-title">Ready to Take the Next Step?</div>
          <div className="affiliate-cards">
            <AffiliateCard name="SmartCredit — 7-Day Trial for $1" desc="Your credit score directly affects your mortgage rate. See yours and start improving it today." cta="Try for $1" href="https://www.jdoqocy.com/click-101704075-16946649" />
            <AffiliateCard name="Northwestern Mutual" desc="Get a personalized financial plan before taking on a mortgage" cta="Talk to an Advisor" href="https://www.northwesternmutual.com/get-started/financial-advisor" />
          </div>
        </div>
        <div className="faq-section">
          <div className="faq-title">Common Questions</div>
          <FaqItem q="What is the 28/36 rule?" a={"The 28/36 rule says: spend no more than 28% of gross income on housing costs, and no more than 36% on total debt. Banks often approve loans up to 43% DTI — but that doesn't mean it's comfortable to live with."} />
          <FaqItem q="How does the down payment affect what I can afford?" a="A larger down payment directly reduces your loan amount, lowers your monthly payment, and helps you avoid PMI which typically costs 0.5–1% of the loan annually." />
          <FaqItem q="15-year vs 30-year mortgage?" a="A 15-year mortgage saves significantly on interest but the payment is 30–40% higher. A 30-year offers lower monthly payments and flexibility. Never stretch to make the 15-year work." />
        </div>
      </div>
      <PageFooter />
    </div>
  );
}

// ─── RETIREMENT ──────────────────────────────────────────────────────────────
export function RetirementCalc({ currency }) {
  const [age, setAge] = useState(30);
  const [retAge, setRetAge] = useState(65);
  const [save, setSave] = useState(0);
  const [contrib, setContrib] = useState(500);
  const [ret, setRet] = useState(7);
  const [want, setWant] = useState(4000);

  const years = Math.max(0, retAge - age);
  const r = ret / 100 / 12;
  const n = years * 12;
  const fv = save * Math.pow(1 + r, n) + contrib * (Math.pow(1 + r, n) - 1) / r;
  const monthlyIncome = fv * 0.04 / 12;
  const gap = monthlyIncome - want;
  const contributed = save + contrib * n;

  const insight = gap >= 0
    ? `Great news — you're on track! Your projected ${fmt(fv, currency)} nest egg will generate about ${fmt(monthlyIncome, currency)}/month in retirement, which is ${fmt(gap, currency)} more than your ${fmt(want, currency)} target. Compound growth will contribute ${fmt(fv - contributed, currency)} — money working for you while you sleep.`
    : `You have a ${fmt(Math.abs(gap), currency)}/month gap at retirement. The good news: you have ${years} years to close it. Increasing your monthly contribution by roughly ${fmt(Math.abs(gap * 3), currency)} could get you there — small increases now have outsized impact later.`;

  return (
    <div>
      <div className="calc-page">
        <Breadcrumb label="Retirement Savings Calculator" />
        <h1 className="calc-page-title">Am I Saving Enough for Retirement?</h1>
        <p className="calc-page-desc">Find out if you're on track before it's too late to course-correct.</p>
        <AdSlot />
        <div className="calculator-box">
          <div className="calc-inputs">
            <InputSlider label="Current Age" value={age} min={18} max={65} step={1} onChange={setAge} display={age} />
            <InputSlider label="Retirement Age" value={retAge} min={50} max={75} step={1} onChange={setRetAge} display={retAge} />
            <InputSlider label="Current Savings" value={save} min={0} max={500000} step={5000} onChange={setSave} display={fmt(save, currency)} />
            <InputSlider label="Monthly Contribution" value={contrib} min={0} max={5000} step={50} onChange={setContrib} display={fmt(contrib, currency)} />
            <InputSlider label="Expected Annual Return" value={ret} min={4} max={12} step={0.5} onChange={setRet} display={ret + '%'} />
            <InputSlider label="Desired Monthly Retirement Income" value={want} min={1000} max={15000} step={250} onChange={setWant} display={fmt(want, currency)} />
          </div>
          <div className="calc-results">
            <div className="result-headline">Projected Retirement Savings</div>
            <div className="result-big">{fmt(fv, currency)}</div>
            <div className="result-grid">
              <ResultItem label="Monthly Income Generated" value={fmt(monthlyIncome, currency)} variant="good" />
              <ResultItem label="Monthly Gap / Surplus" value={(gap >= 0 ? '+' : '') + fmt(gap, currency)} variant={gap >= 0 ? 'good' : 'bad'} />
              <ResultItem label="Years Until Retirement" value={years} />
              <ResultItem label="Your Total Contributions" value={fmt(contributed, currency)} />
            </div>
          </div>
        </div>
        <InsightBox text={insight} />
        <ShareSection
          lines={[
            { text: 'Retirement Check', style: 'bold', size: 52, color: '#D4A017' },
            { text: gap >= 0 ? `On track to retire at ${retAge}` : `Retirement gap detected`, style: 'bold', size: 50, color: 'white' },
            { text: gap >= 0 ? `Projected: ${fmt(fv, currency)}` : `Gap: ${fmt(Math.abs(gap), currency)}/month`, size: 44, color: gap >= 0 ? '#52b788' : '#e63946' },
            { text: 'Are you on track?', size: 36, color: 'rgba(255,255,255,0.5)' },
          ]}
          text={gap >= 0 ? `I'm on track to retire at ${retAge} with ${fmt(fv, currency)}. Are you?` : `I just found out I have a ${fmt(Math.abs(gap), currency)}/month retirement gap. Eye-opening.`}
          url="https://financecalculator.cc/retirement"
          title="Share Your Result"
          subtitle="Are your friends on track for retirement?"
        />
        <AdSlot />
        <div className="affiliate-section">
          <div className="affiliate-title">Start or Grow Your Retirement Savings</div>
          <div className="affiliate-cards">
            <AffiliateCard name="Northwestern Mutual" desc="Tax-free growth and automatic investing — the best retirement account for most people" cta="Open Free" href="https://www.northwesternmutual.com/get-started/investments" />
            <AffiliateCard name="Northwestern Mutual Financial Advisor" desc="Get a personalized retirement plan from a real advisor" cta="Get Started" href="https://www.northwesternmutual.com/get-started/financial-advisor" />
          </div>
        </div>
        <div className="faq-section">
          <div className="faq-title">Common Questions</div>
          <FaqItem q="What is the 4% withdrawal rule?" a="The 4% rule suggests you can withdraw 4% of your retirement savings per year without running out of money over a 30-year retirement. This calculator uses it to estimate monthly income from your projected savings." />
          <FaqItem q="What return rate should I use?" a="The US stock market has historically returned about 10% annually before inflation, or ~7% after inflation. Using 6–7% is a conservative and realistic estimate for a diversified portfolio." />
          <FaqItem q="Should I include Social Security?" a={"The calculator doesn't include Social Security because its future amounts are uncertain, especially for younger savers. Treat any Social Security income as a bonus on top of your personal savings goal."} />
        </div>
      </div>
      <PageFooter />
    </div>
  );
}

// ─── DEBT VS INVEST ───────────────────────────────────────────────────────────
export function DebtInvestCalc({ currency }) {
  const [debtRate, setDebtRate] = useState(20);
  const [invRate, setInvRate] = useState(8);
  const [amt, setAmt] = useState(500);
  const [yrs, setYrs] = useState(10);
  const [bal, setBal] = useState(10000);

  const monthlyDebt = debtRate / 100 / 12;
  let debtBal = bal;
  let monthsToPayoff = 0;
  while (debtBal > 0 && monthsToPayoff < yrs * 12) {
    debtBal -= (amt - debtBal * monthlyDebt);
    monthsToPayoff++;
  }
  const remainingMonths = yrs * 12 - monthsToPayoff;
  const r = invRate / 100 / 12;
  const investAfterDebt = amt * (Math.pow(1 + r, remainingMonths) - 1) / r;
  const n = yrs * 12;
  const investFirst = amt * (Math.pow(1 + r, n) - 1) / r;
  const debtCostIfIgnored = bal * Math.pow(1 + monthlyDebt, n) - bal;
  const netInvestFirst = Math.max(0, investFirst - debtCostIfIgnored);
  const debtWins = investAfterDebt >= netInvestFirst;

  const insight = debtWins
    ? `Your debt at ${debtRate}% costs more than your expected ${invRate}% investment return. Paying it off first gives you a guaranteed ${debtRate}% "return" — which beats your investment expectation. Once the debt is gone in roughly ${monthsToPayoff} months, redirect everything to investing.`
    : `Your expected investment return of ${invRate}% beats your debt rate of ${debtRate}%. Mathematically, every dollar invested outgrows the cost of carrying this debt. However: if your employer offers a 401k match, always capture that first regardless.`;

  return (
    <div>
      <div className="calc-page">
        <Breadcrumb label="Pay Off Debt or Invest?" />
        <h1 className="calc-page-title">Should I Pay Off Debt or Invest?</h1>
        <p className="calc-page-desc">The eternal money debate, finally answered for your specific numbers.</p>
        <AdSlot />
        <div className="calculator-box">
          <div className="calc-inputs">
            <InputSlider label="Debt Interest Rate" value={debtRate} min={1} max={35} step={0.5} onChange={setDebtRate} display={debtRate + '%'} />
            <InputSlider label="Expected Investment Return" value={invRate} min={2} max={15} step={0.5} onChange={setInvRate} display={invRate + '%'} />
            <InputSlider label="Amount Available Monthly" value={amt} min={50} max={5000} step={50} onChange={setAmt} display={fmt(amt, currency)} />
            <InputSlider label="Time Horizon" value={yrs} min={1} max={30} step={1} onChange={setYrs} display={yrs + ' years'} />
            <InputSlider label="Debt Balance" value={bal} min={500} max={100000} step={500} onChange={setBal} display={fmt(bal, currency)} />
          </div>
          <div className="calc-results">
            <div className="result-headline">Our Recommendation</div>
            <div className="result-big" style={{ fontSize: '1.6rem', lineHeight: 1.3 }}>
              {debtWins ? 'Pay Off Debt First' : 'Invest First'}
            </div>
            <div className="compare-grid" style={{ marginTop: 20 }}>
              <div className={`compare-card${debtWins ? ' winner' : ''}`}>
                {debtWins && <div className="winner-label">✓ BETTER OUTCOME</div>}
                <h4>Pay Debt First</h4>
                <div style={{ fontSize: '0.78rem', color: 'var(--muted)', marginBottom: 8 }}>Net worth after {yrs} years</div>
                <div className="big-num">{fmt(investAfterDebt, currency)}</div>
              </div>
              <div className={`compare-card${!debtWins ? ' winner' : ''}`}>
                {!debtWins && <div className="winner-label">✓ BETTER OUTCOME</div>}
                <h4>Invest First</h4>
                <div style={{ fontSize: '0.78rem', color: 'var(--muted)', marginBottom: 8 }}>Net worth after {yrs} years</div>
                <div className="big-num">{fmt(netInvestFirst, currency)}</div>
              </div>
            </div>
          </div>
        </div>
        <InsightBox text={insight} />
        <ShareSection
          lines={[
            { text: 'Debt vs. Invest', style: 'bold', size: 52, color: '#D4A017' },
            { text: 'The math says:', size: 36, color: 'rgba(255,255,255,0.6)' },
            { text: debtWins ? 'Pay off debt first' : 'Invest first', style: 'bold', size: 66, color: 'white' },
            { text: debtWins ? `${debtRate}% debt beats ${invRate}% return` : `${invRate}% return beats ${debtRate}% debt`, size: 38, color: 'rgba(255,255,255,0.65)' },
            { text: 'What does your math say?', size: 34, color: 'rgba(255,255,255,0.45)' },
          ]}
          text={debtWins ? `The math says I should pay off my debt first. My ${debtRate}% debt beats my ${invRate}% return. See yours.` : `The math says I should invest instead of paying off debt. My ${invRate}% return beats my ${debtRate}% debt rate. See yours.`}
          url="https://financecalculator.cc/debt-invest"
          title="Share Your Result"
          subtitle="The debt vs invest debate — what do your numbers say?"
        />
        <AdSlot />
        <div className="affiliate-section">
          <div className="affiliate-title">Take Action on Your Decision</div>
          <div className="affiliate-cards">
            <AffiliateCard name="LifeLock Credit Freeze" desc="If paying debt, protect your credit while you pay it down" cta="Freeze My Credit" href="https://buy.norton.com/aff_creditfreeze" />
            <AffiliateCard name="Northwestern Mutual" desc="If investing, get a personalized plan to maximize your returns" cta="Start Investing" href="https://www.northwesternmutual.com/get-started/investments" />
          </div>
        </div>
        <div className="faq-section">
          <div className="faq-title">Common Questions</div>
          <FaqItem q="Is there ever a reason to invest even with high-interest debt?" a="Yes — one big exception: if your employer offers a 401k match, always contribute enough to capture the full match first. A 50–100% match is an instant guaranteed return that beats almost any debt payoff." />
          <FaqItem q={"What interest rate is the \"break-even\" point?"} a="Generally, if your debt rate is above the expected investment return, pay debt first. The stock market has historically returned about 8% annually, so debt above 8% is usually worth paying first." />
          <FaqItem q="What about low-interest debt like student loans or mortgages?" a="For debt under 5-6%, the math often favors investing — especially in tax-advantaged accounts. The peace of mind from being debt-free has real value too." />
        </div>
      </div>
      <PageFooter />
    </div>
  );
}

// ─── RAISE ───────────────────────────────────────────────────────────────────
function federalTax(income, filing) {
  const brackets = filing === 'single'
    ? [[11600,0.10],[47150,0.12],[100525,0.22],[191950,0.24],[243725,0.32],[609350,0.35],[Infinity,0.37]]
    : [[23200,0.10],[94300,0.12],[201050,0.22],[383900,0.24],[487450,0.32],[731200,0.35],[Infinity,0.37]];
  let tax = 0, prev = 0;
  for (const [limit, rate] of brackets) {
    if (income <= prev) break;
    tax += (Math.min(income, limit) - prev) * rate;
    prev = limit;
  }
  return tax;
}

export function RaiseCalc({ currency }) {
  const [curr, setCurr] = useState(60000);
  const [newSal, setNewSal] = useState(65000);
  const [k401, setK401] = useState(6);
  const [filing, setFiling] = useState('single');

  const gross = newSal - curr;
  const contrib401k = gross * k401 / 100;
  const fedTaxOnRaise = federalTax(newSal - newSal * k401 / 100, filing) - federalTax(curr - curr * k401 / 100, filing);
  const stateTax = (gross - contrib401k) * 0.05;
  const fica = gross * 0.0765;
  const net = gross - fedTaxOnRaise - stateTax - fica;

  const insight = `Your ${fmt(gross, currency)} raise translates to about ${fmt(net / 26, currency)} in each bi-weekly paycheck. The gap between your raise on paper and in your pocket (${fmt(gross - net, currency)}) goes to federal tax, a ~5% state estimate, and Social Security/Medicare. Your 401k contribution of ${fmt(contrib401k, currency)} reduces your taxable income — you still keep that money, just in your retirement account.`;

  return (
    <div>
      <div className="calc-page">
        <Breadcrumb label="Salary Raise Calculator" />
        <h1 className="calc-page-title">What's My Raise Actually Worth?</h1>
        <p className="calc-page-desc">Find out what actually lands in your pocket after taxes and deductions.</p>
        <AdSlot />
        <div className="calculator-box">
          <div className="calc-inputs">
            <InputSlider label="Current Annual Salary" value={curr} min={20000} max={500000} step={1000} onChange={setCurr} display={fmt(curr, currency)} />
            <InputSlider label="New Annual Salary" value={newSal} min={20000} max={500000} step={1000} onChange={setNewSal} display={fmt(newSal, currency)} />
            <InputSlider label="401k Contribution" value={k401} min={0} max={25} step={1} onChange={setK401} display={k401 + '%'} />
            <div className="input-group">
              <div className="input-label"><span>Filing Status</span></div>
              <ToggleGroup options={[{ value: 'single', label: 'Single' }, { value: 'married', label: 'Married' }]} value={filing} onChange={setFiling} />
            </div>
          </div>
          <div className="calc-results">
            <div className="result-headline">Your raise in your pocket</div>
            <div className="result-big">{fmt(net, currency)}</div>
            <div className="result-sub">per year ({fmt(net / 12, currency)}/month)</div>
            <div className="result-grid">
              <ResultItem label="Raise on Paper (Gross)" value={fmt(gross, currency)} />
              <ResultItem label="Federal + State Tax" value={'-' + fmt(fedTaxOnRaise + stateTax, currency)} variant="bad" />
              <ResultItem label="FICA (Social Security)" value={'-' + fmt(fica, currency)} variant="bad" />
              <ResultItem label="401k (You Still Keep This)" value={'+' + fmt(contrib401k, currency)} variant="good" />
            </div>
            <div style={{ marginTop: 16, background: 'var(--green-pale)', borderRadius: 'var(--radius-sm)', padding: '14px 18px', borderLeft: '4px solid var(--green)' }}>
              <div style={{ fontSize: '0.78rem', color: 'var(--green)', fontWeight: 700, marginBottom: 4 }}>EXTRA PER PAYCHECK</div>
              <div style={{ fontSize: '1.4rem', fontWeight: 700, color: 'var(--green)' }}>{'+' + fmt(net / 26, currency)}</div>
            </div>
          </div>
        </div>
        <InsightBox text={insight} />
        <ShareSection
          lines={[
            { text: 'Salary Raise Calculator', style: 'bold', size: 46, color: '#D4A017' },
            { text: `${fmt(gross, currency)} raise on paper`, size: 40, color: 'rgba(255,255,255,0.6)' },
            { text: `${fmt(net, currency)} in my pocket`, style: 'bold', size: 66, color: 'white' },
            { text: `+${fmt(net / 26, currency)} per paycheck`, size: 40, color: '#52b788' },
            { text: 'What is your raise really worth?', size: 34, color: 'rgba(255,255,255,0.45)' },
          ]}
          text={`My ${fmt(gross, currency)} raise puts ${fmt(net, currency)} in my pocket after tax. That is ${fmt(net / 26, currency)} extra per paycheck. What is yours worth?`}
          url="https://financecalculator.cc/raise"
          title="Share Your Result"
          subtitle="Show your friends what their raise is really worth"
        />
        <AdSlot />
        <div className="affiliate-section">
          <div className="affiliate-title">Put Your Raise to Work</div>
          <div className="affiliate-cards">
            <AffiliateCard name="Northwestern Mutual" desc="Automatically invest your raise increase so it builds wealth without thinking about it" cta="Start Investing" href="https://www.northwesternmutual.com/get-started/investments" />
            <AffiliateCard name="LifeLock Identity Protection" desc="As your income grows, protect yourself from identity theft and fraud" cta="Get Protected" href="https://buy.norton.com/aff_LifeLock" />
          </div>
        </div>
        <div className="faq-section">
          <div className="faq-title">Common Questions</div>
          <FaqItem q="Why does my raise feel so small?" a="Because taxes take a significant cut — especially of raises, since they may push you into a higher marginal bracket. Your effective tax rate applies to all income, but only the marginal rate applies to new income above each bracket threshold." />
          <FaqItem q="Should I increase my 401k contribution with a raise?" a={"Absolutely. When you get a raise, increase your 401k contribution by 1-2%. Since you weren't spending that money before, you won't miss it — and it builds retirement wealth while reducing your taxable income right now."} />
          <FaqItem q="How accurate is this calculator?" a="This uses simplified federal tax brackets and an approximate 5% state income tax. Your actual tax may differ based on your specific state, deductions, and credits. Best used to understand the general magnitude of your take-home increase." />
        </div>
      </div>
      <PageFooter />
    </div>
  );
}

// ─── MILLIONAIRE ─────────────────────────────────────────────────────────────
export function MillionaireCalc({ currency }) {
  const [curr, setCurr] = useState(10000);
  const [contrib, setContrib] = useState(500);
  const [ret, setRet] = useState(8);
  const [target, setTarget] = useState(1000000);

  const r = ret / 100 / 12;
  let months = 0, bal = curr;
  while (bal < target && months < 1200) { bal = bal * (1 + r) + contrib; months++; }
  const reached = bal >= target;
  const yrs = Math.floor(months / 12);
  const mo = months % 12;
  const totalContrib = curr + contrib * months;
  const growth = target - totalContrib;
  const timeStr = reached ? (yrs > 0 ? `${yrs} year${yrs !== 1 ? 's' : ''}${mo > 0 ? `, ${mo} month${mo !== 1 ? 's' : ''}` : ''}` : `${mo} months`) : '100+ years';

  const milestones = [0.25, 0.5, 0.75, 1.0].map(pct => {
    const t = target * pct;
    let m = 0; let b = curr;
    while (b < t && m < 1200) { b = b * (1 + r) + contrib; m++; }
    return { label: fmt(t, currency), years: Math.floor(m / 12), months: m % 12, reached: b >= t };
  });

  const insight = `Of your ${fmt(target, currency)} goal, you'll personally contribute ${fmt(Math.min(totalContrib, target), currency)} — just ${Math.round((Math.min(totalContrib, target) / target) * 100)}% of the total. The other ${fmt(Math.max(0, growth), currency)} comes entirely from compound growth. This is why starting early matters more than investing large amounts later.`;

  const shareText = reached
    ? `${fmt(contrib, currency)}/month turns into ${fmt(target, currency)} in ${timeStr}. This number will surprise you.`
    : `I just calculated my path to ${fmt(target, currency)}. This number will surprise you.`;

  const shareUrl = 'https://financecalculator.cc/millionaire';

  return (
    <div>
      <div className="calc-page">
        <Breadcrumb label="Millionaire Calculator" />
        <h1 className="calc-page-title">How Long Until I'm a Millionaire?</h1>
        <p className="calc-page-desc">Compound interest is genuinely mind-bending. See what consistent saving and time can build.</p>
        <AdSlot />
        <div className="calculator-box">
          <div className="calc-inputs">
            <InputSlider label="Current Savings" value={curr} min={0} max={500000} step={1000} onChange={setCurr} display={fmt(curr, currency)} />
            <InputSlider label="Monthly Contribution" value={contrib} min={0} max={10000} step={50} onChange={setContrib} display={fmt(contrib, currency)} />
            <InputSlider label="Expected Annual Return" value={ret} min={1} max={15} step={0.5} onChange={setRet} display={ret + '%'} />
            <InputSlider label="Target Amount" value={target} min={100000} max={5000000} step={50000} onChange={setTarget} display={fmt(target, currency)} />
          </div>
          <div className="calc-results">
            <div className="result-headline">You'll hit your goal in</div>
            <div className="result-big">{timeStr}</div>
            <div className="result-grid">
              <ResultItem label="You Will Contribute" value={fmt(Math.min(totalContrib, target), currency)} variant="good" />
              <ResultItem label="Compound Growth Adds" value={fmt(Math.max(0, growth), currency)} variant="good" />
            </div>
            <div style={{ marginTop: 20 }}>
              <div style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: 12, color: 'var(--muted)' }}>Your Milestones</div>
              <div className="milestones">
                {milestones.map((m, i) => (
                  <div key={i} className="milestone">
                    <div className="milestone-dot" style={{ background: m.reached ? 'var(--green)' : 'var(--border)' }} />
                    <div className="milestone-label">{m.label} milestone</div>
                    <div className="milestone-value">{m.reached ? (m.years > 0 ? `${m.years}yr ` : '') + (m.months > 0 ? `${m.months}mo` : '') : '—'}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <InsightBox text={insight} />
        <ShareSection
          lines={[
            { text: `${fmt(contrib, currency)}/month`, style: 'bold', size: 68, color: '#D4A017' },
            { text: 'turns into', size: 36, color: 'rgba(255,255,255,0.55)' },
            { text: fmt(target, currency), style: 'bold', size: 80, color: 'white' },
            { text: reached ? `In ${timeStr}` : 'Check your timeline', style: 'bold', size: 52, color: '#52b788' },
            { text: 'This number will surprise you.', size: 34, color: 'rgba(255,255,255,0.45)' },
          ]}
          text={shareText}
          url={shareUrl}
          title="Share Your Result"
          subtitle="Challenge your friends to beat your timeline!"
        />
        <AdSlot />
        <div className="affiliate-section">
          <div className="affiliate-title">Start Building Your Million Today</div>
          <div className="affiliate-cards">
            <AffiliateCard name="Northwestern Mutual" desc="Start investing today — even small amounts compound into big numbers" cta="Begin Investing" href="https://www.northwesternmutual.com/get-started/investments" />
            <AffiliateCard name="Northwestern Mutual Whole Life" desc="Protect your wealth as it grows with life insurance that builds cash value" cta="Learn More" href="https://www.northwesternmutual.com/get-started/whole-life-insurance" />
          </div>
        </div>
        <div className="faq-section">
          <div className="faq-title">Common Questions</div>
          <FaqItem q="Is $1 million enough to retire on?" a={"Using the 4% withdrawal rule, $1 million generates about $40,000/year or $3,333/month. Whether that's enough depends entirely on your lifestyle and location."} />
          <FaqItem q={"What's the best account to use to build this?"} a="(1) Capture your full 401k employer match first. (2) Max out a Roth IRA. (3) Return to your 401k. (4) Use a regular brokerage account for anything beyond that." />
          <FaqItem q="What return rate is realistic?" a="The S&P 500 has returned about 10% annually historically, or about 7% after inflation. Use 7–8% for a realistic projection with a diversified index fund portfolio." />
        </div>
      </div>
      <PageFooter />
    </div>
  );
}
